var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('text-field',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.isLoading.address),expression:"isLoading.address"}],attrs:{"id":"city-field","validation":_vm.$v,"validationMessage":_vm.textRequired,"element-loading-spinner":"el-icon-loading","label":_vm.textLabel,"rest":{
    placeholder: _vm.placeholder
      ? _vm.textLabel
      : null,
    autocomplete: 'shipping locality',
    name: 'city',
  },"theme":"variant-1","tabindex":_vm.tabindex,"order":_vm.order},model:{value:(_vm.form[_vm.name]),callback:function ($$v) {_vm.$set(_vm.form, _vm.name, $$v)},expression:"form[name]"}})}
var staticRenderFns = []

export { render, staticRenderFns }